import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';

import TicketsView from './TicketsView.vue';

// Required: routeIsAccessibleFor treats an empty permission list as "no one",
// so a route without this is unreachable for every user. ROLES must be included
// alongside the custom-role permissions, or plain agents and administrators are
// locked out.
// `featureFlag` here is a single flag consumed by the sidebar provider's
// `shouldShow`; the router guard (routeIsAccessibleFor) only enforces
// permissions. So when the ticket engine (`support_cases`) supersedes this
// lens, every navigation entry point is gated instead (sidebar, rail create
// menu, command bar, convert button) while the URLs stay reachable, matching
// the repo's hidden-nav-but-reachable route precedent.
const meta = {
  featureFlag: FEATURE_FLAGS.TICKETS,
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
};

const ticketsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/tickets'),
      // Views (All, Unassigned, My open, one per state) are query params on
      // this route, so a view is a shareable URL rather than a seeded filter
      // record. The open ticket is a path segment instead, mirroring the chat
      // inbox, so the list and the thread deep-link the same way on both
      // screens.
      name: 'tickets_index',
      meta,
      component: TicketsView,
    },
    {
      path: frontendURL('accounts/:accountId/tickets/:conversationId'),
      name: 'tickets_conversation',
      meta,
      component: TicketsView,
      props: route => ({ conversationId: route.params.conversationId }),
    },
  ],
};

export default ticketsRoutes;
